<template>
  <div class="cpWrapper">
    <!-- <div class="listWrapper" @click="showCheckWrapper">
      <img width="14" height="14" src="../../assets/show.png" alt="">
      <span>显示列</span>
      <i v-if="showList" class="el-icon-arrow-up"></i>
      <i v-else class="el-icon-arrow-down"></i>
    </div>
    <div ref="checkWrapper" class="checkWrapper" v-if="showList">
      <i class="el-icon-arrow-up arrowUp"></i>
      <div class="arrowLine"></div>
      <div class="checkList">
        <el-checkbox-group v-model="checkList" @change="listChange" class="checkboxGroup">
          <el-checkbox :label="item.label" v-for="(item,index) in options" :key="index"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div> -->

	<el-popover placement="bottom" popper-class="showListPopper" trigger="click" v-model="showList">
	  <div ref="checkWrapper" class="checkWrapper">
	    <div class="checkList">
	      <el-checkbox-group v-model="checkList" @change="listChange" class="checkboxGroup">
	        <el-checkbox :label="item.label" v-for="(item,index) in options" :key="index"></el-checkbox>
	      </el-checkbox-group>
	    </div>
	  </div>
	  <el-button slot="reference" class="listWrapper">
      <div style="display: flex;align-items: center;">
        <img width="14" height="14" src="../../assets/show.png" alt="">
        <span>显示列</span>
        <i v-if="showList" class="el-icon-arrow-up"></i>
        <i v-else class="el-icon-arrow-down"></i>
      </div>
    </el-button>
	</el-popover>
  </div>
</template>

<script>
  import {setCookie,getCookie} from '../../utils/support.js';
  // import { mapGetters } from 'vuex'
  var ls = window.localStorage;

  export default {
    props: {
      tableLabel: { // 父组件传递过来的表头数据
        type: Array
      },
      companyId:{
        type: [Number,String],
        default: 2
      },
      smallType:{
        type: [Number,String],
        default: ''
      },
    },
    data() {
      return {
        // showWrapper:false,
        options: [],
        checkList: [],
        showList:false,
        company_id:2,
        storageKey:'',
      }
    },
    // computed: {
    //   ...mapGetters([
    //     'showList',
    //   ])
    // },
    created() {
      // this.intTableLabel()
      this.routeChange();
    },
    watch: {
      $route() {
        this.routeChange();
      },
      tableLabel:{
        immediate: true,    // 这句重要
        handler(newValue, oldValue){
          this.tableLabel.forEach((item, index) => {
            if (item.prop=='price') {
              // console.log(56565,item,index,newValue[index].label)
              item.label = newValue[index].label
            }
          });
          if (this.smallType) {
            this.storageKey = `${this.smallType}TableLabel`
          }else{
            this.storageKey = `${this.$route.name}TableLabel`
          }
          this.intTableLabel(newValue)
        },
        deep:true,
      },
      companyId:{
        immediate: true,
        handler(newValue, oldValue){
          let tableLabel
          this.company_id = newValue
          tableLabel=JSON.parse(ls.getItem('orderDetailTableLabel1'))
          // if (this.company_id==1) {
          //   tableLabel=JSON.parse(ls.getItem('orderDetailTableLabel1'))
          // } else if(this.company_id==5){
          //   tableLabel=JSON.parse(ls.getItem('orderDetailTableLabel5'))
          // }else{
          //   tableLabel=JSON.parse(ls.getItem('orderDetailTableLabel2'))
          // }
        },
        deep:true,
      },

    },
    methods: {
      intTableLabel(tableLabel){
        // console.log('tableLabel111',tableLabel)
        // 判断是否有缓存
        // var ls = window.localStorage;
        // let tableLabel=JSON.parse(ls.getItem('tableLabel'))
        // if (!tableLabel) {
        //   tableLabel = this.tableLabel
        // }
        this.checkList = []
        this.options = []
        for (let i = 0; i < tableLabel.length; i++) {
          // 初始化列表
          this.options.push({label: tableLabel[i].label,value: tableLabel[i].prop});
          // 判断是否显示状态
          if (tableLabel[i].show) {
            this.checkList.push(tableLabel[i].label);
          }
        }
      },
      showCheckWrapper(){
        this.$store.dispatch('ShowCheckList');
      },
      listChange(val){
        // console.log('val',this.checkList)
        this.$emit('change', this.checkList);
      },
      routeChange(){

        var url = this.$route.path
        let tableLabel
        // if (url=='/customer/customerCP') {
        //   tableLabel=JSON.parse(ls.getItem('customerTableLabel'))
        // } else if(url=='/customer/highSeas'){
        //   tableLabel=JSON.parse(ls.getItem('c_highSeasTableLabel'))
        // } else if(url=='/product/productCP'){
        //   tableLabel=JSON.parse(ls.getItem('productTableLabel'))
        // } else if(url=='/SHistory/SHistoryCP'){
        //   tableLabel=JSON.parse(ls.getItem('p_SHistoryTableLabel'))
        // } else if(url=='/select/cart'){
        //   tableLabel=JSON.parse(ls.getItem('p_selectTableLabel'))
        // } else if(url=='/product/productHighSeas'){
        //   tableLabel=JSON.parse(ls.getItem('p_productHighSeasTableLabel'))
        // } else if(url=='/quotedPrice/quotedPriceCP'){
        //   tableLabel=JSON.parse(ls.getItem('quotedPriceTableLabel'))
        // } else if(url=='/bills/billsCP'){
        //   tableLabel=JSON.parse(ls.getItem('bills_orderTableLabel'))
        // } else if(url=='/pack/packCP'){
        //   tableLabel=JSON.parse(ls.getItem('bills_packTableLabel'))
        // } else if(url=='/packingCp/packing'){
        //   tableLabel=JSON.parse(ls.getItem('bills_packingTableLabel'))
        // } else if(url=='/customer/c_addressBook'){
        //   tableLabel=JSON.parse(ls.getItem('c_addressBook'))
        // } else if(url=='/purchaseResponse/purchaseResponseCP'){
        //   tableLabel=JSON.parse(ls.getItem('purchaseResponse'))
        // } else if(url=='/quotedPrice/quotedHistory'){
        //   tableLabel=JSON.parse(ls.getItem('quotedHistoryTableLabel'))
        // } else if(url=='/trackingPlan/trackingPlanCP'){
        //   tableLabel=JSON.parse(ls.getItem('trackingPlanTableLabel'))
        // } else if(url=='/bills/orderReview'){
        //   tableLabel=JSON.parse(ls.getItem('orderReviewTableLabel'))
        // } else if(url=='/bills/shipmentPlan'){
        //   tableLabel=JSON.parse(ls.getItem('shipmentPlanTableLabel'))
        // } else if(url=='/bills/orderStock'){
        //   tableLabel=JSON.parse(ls.getItem('orderStockTableLabel'))
        // } else if(url=='/historicalDelivery'){
        //   tableLabel=JSON.parse(ls.getItem('historicalDeliveryTableLabel'))
        // }

        tableLabel=JSON.parse(ls.getItem(this.storageKey))

        if (!tableLabel) {
          tableLabel = this.tableLabel
        }
        // console.log('tableLabel',tableLabel)
        // this.intTableLabel(tableLabel)
      },

    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

  .cpWrapper{
    position: relative;
    .listWrapper{
      // width: 150px;
      width: 100px;
      height: 30px;
      border: 1px solid #DCDFE6;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 12px;
      color: #303133;
      padding: 10px;
      cursor: pointer;
      img{
        margin-right: 8px;
      }
      i{
        // margin-left: 30px;
        margin-left: 10px;
      }
    }
    .checkWrapper{
      position: absolute;
      top: 45px;
      z-index: 99;
    }
    .checkList{
      width: 150px;
      height: 400px;
      background: #FFFFFF;
      border: 1px solid #DCDFE6;
      border-radius: 3px;
      padding: 12px;
      overflow: auto;
      line-height: 30px;
    }
    .checkList /deep/ .el-checkbox{
      display: block;
    }
    .arrowUp{
    	position: absolute;
    	top: -13px;
    	left: 20px;
    	color: #DFE2E8;
    	font-size: 18px;
    }
    .arrowLine{
    	width: 11px;
    	height: 1px;
    	position: absolute;
    	top: 0px;
    	left: 23px;
    	background-color: white;
    }
    // .checkList::before{
    //   display: inline-block;
    //   content: "";
    //   height: 16px;
    //   width: 16px;
    //   background: url(../../assets/prompt.png) no-repeat;
    //   background-size: 100%;
    //   vertical-align: text-top;
    // }
    .selectList{
      position: absolute;
      top: 0;
      height: 40px;
      overflow: hidden;
      opacity: 0;
    }
    .selectList /deep/ .el-select__tags{
      display: none;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/showList/index.vue